import { ErrorSidePanel } from '@/components/errors';
import { templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useGetLoginOptions } from '../../../../-hooks/login-options.hook';
import { useRemoveUsername } from './-hooks/remove-username.hooks';
import { type UsernameProps } from './-model/props';
import { UsernameLight } from './-skins';

export const Route = createFileRoute(
  '/(home)/home/(change-contacts)/_sheet/change-contacts/username/',
)({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { data: loginOptions, isLoading } = useGetLoginOptions();

  const username =
    loginOptions?.UsernameAliases.find((alias) => alias.Type === 'Other')?.Username ?? '';

  const { mutate: removeUsername, isPending: isRemoving } = useRemoveUsername({
    onSuccess: () => {
      navigate({ to: '/home' });
    },
  });

  const props: UsernameProps = {
    username,
    isLoading,
    isRemoving,
    onRemove: () => removeUsername(),
  };

  return templates.getSkinSelector(skinConfig(props));
}

export function skinConfig(props: UsernameProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <UsernameLight {...props} />,
  };
}
